import { render } from "./LochGenerator.vue?vue&type=template&id=1db9d053"
import script from "./LochGenerator.vue?vue&type=script&lang=js"
export * from "./LochGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__